import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

import { Flip, ToastContainer, toast } from "react-toastify";
import { ArrowRight } from "lucide-react";
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
// import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

// type ValuePiece = Date | null;

// type Value = ValuePiece | [ValuePiece, ValuePiece];

const CreateMatch = () => {

  const [disabled, setDisabled] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [date, setNewDate] = useState<Date | null>(new Date());

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();


  return (
    <div className="container mx-auto  ">
      <div className="container bg-black p-4 rounded-xl bg-opacity-50 mx-auto ">
        <ToastContainer />
        <div className="text-lg uppercase font-bold">deposit</div>
        <small>deposit funds into your account.</small>

        <div  className="mt-4">
          <div className="">
            <form
              className=" "
              id="depositForm"
              onSubmit={
                handleSubmit(async (data) => {
                
                console.log(data,"this is date",date);
                const formDate = {
                   game: data.game,
                    fees: data.fees,
                    type: data.type,
                    status:"open",
                    totalSlots:data.totalSlots,
                    filledSlots:0,
                    availableSlots:0,
                    picture:"String",
                    server:data.server,
                    matchtype:data.matchtype,
                    closingTime:date,
                    participants:[]
  
                }
                
                await axiosPrivate
                .post("/listings/createMatchCard",formDate ,{
                  withCredentials: true,
                }).then((res)=>{
                  console.log(res.data)
                  toast.success(
                    `A new match with matchId : ${res?.data?.matchId} has been created successfully! 👌`,
                    {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "colored",
                      transition: Flip,
                    }
                  );
                  reset({
                    game: "PUBG MOBILE",
                    fees: "", // Example: filtering by fee range
                    type: "", // Example: filtering by type
                    matchType: "", // Example: filtering by match type
                    server: "",
                    totalSlots:"" // or any default value you want to set
                  });
                }).catch(err=>{
                  toast.error("Something went wrong!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                  });
                  console.log(err);
                  reset({
                    game: "PUBG MOBILE",
                    fees: "", // Example: filtering by fee range
                    type: "", // Example: filtering by type
                    matchType: "", // Example: filtering by match type
                    server: "",
                    totalSlots:"" // or any default value you want to set
                  });
                })
              })
            }
            >
              <div className="grid grid-cols-2 grid-rows-1 gap-4">
                <div className="mx-10">
                  <div className="my-2">
                    <label>Game Type : </label>
                  </div>
                  <div>
                    <select
                      {...register("game", {
                        required: "This field is required.",
                      })}
                      className={`block appearance-none  w-full bg-gray-200 border border-gray-200 ${
                        errors.Country?.message ? "border-red-700" : null
                      } text-gray-700 py-3 px-4 pr-8 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                      id="grid-state-country"
                      defaultValue="Select Country"
                    >
                      <option value="PUBG MOBILE" >
                        PUBG Mobile - Player Unknowns Battle Ground
                      </option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    <p className="text-red-500 text-xs italic">
                      {/* {errors.Country?.message} */}
                    </p>
                  </div>
                </div>

                <div className="mx-10">
                  <div className="my-2">
                    <label>Match Type : </label>
                  </div>
                  <div>
                    <select
                      {...register("matchtype", {
                        required: "This field is required.",
                      })}
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                        errors.Country?.message ? "border-red-700" : null
                      } text-gray-700 py-3 px-4 pr-8  text-xs rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                      id="grid-state-country"
                      defaultValue="Select Mode Type"
                    >
                      <option value="Erangle">Erangle</option>
                      <option value="Erangle-themed">Erangle-themed</option>
                      <option value="Livik">Livik</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    <p className="text-red-500 text-xs italic">
                      {/* {errors.Country?.message} */}
                    </p>
                  </div>
                </div>

                <div className="mx-10">
                  <div className="my-2">
                    <label>Server Type : </label>
                  </div>
                  <div>
                    <select
                      {...register("server", {
                        required: "This field is required.",
                      })}
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                        errors.Country?.message ? "border-red-700" : null
                      } text-gray-700 py-3 px-4 pr-8 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                      id="grid-state-country"
                      defaultValue="Select Mode Type"
                    >
                      <option value="Europe">Europe</option>
                      <option value="Middle-east">Middle-east</option>
                      <option value="Asia">Asia</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    <p className="text-red-500 text-xs italic">
                      {/* {errors.Country?.message} */}
                    </p>
                  </div>
                </div>

                <div className="mx-10">
                  <div className="my-2">
                    <label>Fees For Match : </label>
                  </div>
                  <div className="flex  items-center ">
                    <div>
                      <input
                        {...register("fees", {})}
                        className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                          errors.Country?.message ? "border-red-700" : null
                        } text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                        id="grid-state-country"
                      />

                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                          className="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                        </svg>
                      </div>
                    </div>
                    <p className="ms-2 font-bold text-xl">PKR</p>
                    <p className="text-red-500 text-xs italic">
                      {/* {errors.Country?.message} */}
                    </p>
                  </div>
                </div>

                <div className="mx-10">
                  <div className="my-2">
                    <label>Team Type : </label>
                  </div>
                  <div>
                    <select
                      {...register("type", {
                        required: "This field is required.",
                      })}
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                        errors.Country?.message ? "border-red-700" : null
                      } text-gray-700 py-3 px-4 pr-8  text-xs rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                      id="grid-state-country"
                      defaultValue="Select Mode Type"
                    >
                      <option value="single">Single (1)</option>
                      <option value="duo">Duo Squad (2)</option>
                      <option value="squad">Squad (4)</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    <p className="text-red-500 text-xs italic">
                      {/* {errors.Country?.message} */}
                    </p>
                  </div>
                </div>
                <div className="mx-10">
                  <div className="my-2">
                    <label>totalSlots : </label>
                  </div>
                  <div className="flex  items-center ">
                    <input
                      {...register("totalSlots", {})}
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                        errors.Country?.message ? "border-red-700" : null
                      } text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                      id="grid-state-country"
                      type="Number"
                    />
                  </div>
                </div>
                <div className="mt-5">
                  <label>Date time picker</label>
                <DateTimePicker    className={" p-4"}  onChange={(e) => {
                 
        setNewDate(e); // Update the state with the selected date and time
        console.log("Selected DateTime:", e); // Log the selected date and time
      }}
        value={date} />
                </div>
              </div>

              <div className="container flex justify-center items-center mt-4">
                <button type="submit" className="mt-5 w-[200px] tracking-wide flex justify-between px-3 font-semibold bg-purple-500 text-white-500 w-full py-4 rounded-lg hover:bg-purple-700 hover:text-purple-800 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none">
                  <p> Submit</p> <ArrowRight />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateMatch;
